import React, {useCallback} from 'react'
import Icon from "@/view/common/component/Icon";
import BottomButton from "@/view/common/component/button/BottomButton";
import HeaderSpacer from "@/view/layout/HeaderSpacer";


export interface QuestionCompleteParam{
    onClose: () => void
}

const BoardAddComplete = (props: QuestionCompleteParam) => {
    const handleOverlayClick = useCallback(() => props.onClose(), [props.onClose])
    return <>
        <div className={'no-content-wrapper'}>
            <HeaderSpacer/>
            <Icon iconClass={'question-complete'}/>
            <p className={'text-center h5_l mt-35px'}>게시글이 등록되었습니다.</p>
        </div>
        <BottomButton title={'목록으로 돌아가기'}
                      disabled={false}
                      onClick={handleOverlayClick}/>
    </>
}

export default BoardAddComplete